import { useInfiniteQuery } from '@tanstack/vue-query';
import { auditLogService } from '@/api/audit-log.service';
import type { FindAllAuditLogsForEntityDto } from '@/api/audit-log.service';
import { toValue, type MaybeRefOrGetter } from 'vue';

export const useAuditLogByEntity = (params: MaybeRefOrGetter<FindAllAuditLogsForEntityDto>) =>
  useInfiniteQuery({
    queryKey: ['audit-log', params],
    queryFn: ({ pageParam }) =>
      auditLogService.getForEntity({
        ...toValue(params),
        page: pageParam,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage.meta.nextPage,
  });
